import { Component, EventEmitter, Input, Output } from "@angular/core";

import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";

@Component({
  selector: "app-desktop-navigation",
  templateUrl: "./navigation.component.html",
  styleUrls: ["./navigation.component.scss"],
  imports: [FontAwesomeModule],
  standalone: true,
})
export class DesktopNavigationComponent {
  @Input() pageName: string = "";
  @Output() clicked = new EventEmitter<void>();

  goBack() {
    this.clicked.emit();
  }
}
